/* TKMAUTO Cart Drawer Upsell — when cart has a bed cap but no cross bar,
   inject a slim "Add Cross Bar +$259.98" banner at top of the cart drawer.
   Customer clicks → AJAX add → banner disappears. Dismissible (7-day cookie). */
(function(){
  'use strict';

  var UPSELL_HANDLE = 'truck-bed-cap-cross-bar';
  var DISMISS_COOKIE = 'tkm_cb_upsell_dismissed';
  var UPSELL_VARIANT_ID = null; // populated on first cart-fetch
  var UPSELL_PRICE = null;
  var UPSELL_TITLE = 'Truck Bed Cap Cross Bar';
  var UPSELL_IMG = null;

  function getCookie(n){var m=document.cookie.match(new RegExp('(^|; )'+n+'=([^;]+)'));return m?m[2]:'';}
  function setCookie(n,v,days){var d=new Date();d.setTime(d.getTime()+days*86400*1000);document.cookie=n+'='+v+';expires='+d.toUTCString()+';path=/';}
  function money(cents){return '$'+(cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}

  function isBedCapTitle(t){
    if(!t) return false;
    t = t.toLowerCase();
    return t.indexOf('bed cap') >= 0 || t.indexOf('bedcap') >= 0;
  }

  function isCrossBarTitle(t){
    if(!t) return false;
    return t.toLowerCase().indexOf('cross bar') >= 0;
  }

  function fetchUpsellProduct(){
    return fetch('/products/'+UPSELL_HANDLE+'.js')
      .then(function(r){ return r.json(); })
      .then(function(p){
        var v = (p.variants || [])[0];
        if(!v) return null;
        UPSELL_VARIANT_ID = v.id;
        UPSELL_PRICE = v.price;
        UPSELL_TITLE = p.title;
        UPSELL_IMG = (p.featured_image && (p.featured_image.src || p.featured_image)) || (p.images && p.images[0]) || null;
        if(UPSELL_IMG && UPSELL_IMG.indexOf('//') === 0) UPSELL_IMG = 'https:' + UPSELL_IMG;
        return p;
      })
      .catch(function(){ return null; });
  }

  function shouldShow(cart){
    if(!cart || !cart.items) return false;
    if(getCookie(DISMISS_COOKIE)) return false;
    var hasBedCap = false, hasCrossBar = false;
    cart.items.forEach(function(it){
      if(isBedCapTitle(it.product_title || it.title)) hasBedCap = true;
      if(isCrossBarTitle(it.product_title || it.title)) hasCrossBar = true;
      if(it.handle === UPSELL_HANDLE) hasCrossBar = true;
    });
    return hasBedCap && !hasCrossBar;
  }

  function injectStyle(){
    if(document.getElementById('tkmCbUpsellCss')) return;
    var css = document.createElement('style');
    css.id = 'tkmCbUpsellCss';
    css.textContent = [
      '.tkm-cbu{',
      '  margin:12px 14px;padding:12px 14px;',
      '  background:#FAF8F4;border:1px solid #C9A979;border-radius:10px;',
      '  display:flex;align-items:center;gap:12px;',
      '  flex-shrink:0;',   /* lives in the drawer's flex column now — never let it get squeezed */
      '  font-family:"Inter",sans-serif;position:relative;',
      '  animation:tkmCbuIn .35s ease;',
      '}',
      '@keyframes tkmCbuIn{from{opacity:0;transform:translateY(-6px);}to{opacity:1;transform:none;}}',
      '.tkm-cbu__img{width:48px;height:48px;border-radius:8px;background:#F2EEE6;object-fit:cover;flex-shrink:0;border:1px solid #DAD3C4;}',
      '.tkm-cbu__txt{flex:1;min-width:0;line-height:1.25;}',
      '.tkm-cbu__eyebrow{font-family:"Oswald",sans-serif;font-size:9.5px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;color:#A8895E;margin:0 0 2px;}',
      '.tkm-cbu__title{font-size:12.5px;font-weight:600;color:#0E1114;line-height:1.25;}',
      '.tkm-cbu__price{font-family:"Oswald",sans-serif;font-size:13px;font-weight:700;color:#0E1114;margin-top:2px;}',
      '.tkm-cbu__add{',
      '  background:#0E1114;color:#fff;',
      '  font-family:"Oswald",sans-serif;font-size:10.5px;font-weight:700;',
      '  letter-spacing:.18em;text-transform:uppercase;',
      '  padding:9px 14px;border-radius:8px;border:0;cursor:pointer;',
      '  line-height:1;flex-shrink:0;white-space:nowrap;',
      '  transition:background .15s;',
      '}',
      '.tkm-cbu__add:hover,.tkm-cbu__add:focus{background:#C9A979;color:#0E1114;}',
      '.tkm-cbu__add[disabled]{opacity:.6;cursor:not-allowed;}',
      '.tkm-cbu__close{',
      '  position:absolute;top:6px;right:6px;width:18px;height:18px;',
      '  background:transparent;border:0;cursor:pointer;color:#6B6962;',
      '  display:flex;align-items:center;justify-content:center;',
      '  border-radius:50%;transition:background .12s;',
      '}',
      '.tkm-cbu__close:hover{background:rgba(14,17,20,.06);color:#0E1114;}',
      '.tkm-cbu__close svg{width:11px;height:11px;}'
    ].join('');
    document.head.appendChild(css);
  }

  function buildBanner(){
    var div = document.createElement('div');
    div.className = 'tkm-cbu';
    div.id = 'tkmCbUpsell';
    div.innerHTML =
      (UPSELL_IMG ? '<img class="tkm-cbu__img" src="'+UPSELL_IMG+'" alt="">' : '<div class="tkm-cbu__img"></div>') +
      '<div class="tkm-cbu__txt">' +
        '<div class="tkm-cbu__eyebrow">Complete Your Build</div>' +
        '<div class="tkm-cbu__title">'+UPSELL_TITLE+'</div>' +
        '<div class="tkm-cbu__price">+'+money(UPSELL_PRICE)+'</div>' +
      '</div>' +
      '<button class="tkm-cbu__add" type="button">Add</button>' +
      '<button class="tkm-cbu__close" type="button" aria-label="Dismiss">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>';
    return div;
  }

  function attachAddHandler(el){
    var addBtn = el.querySelector('.tkm-cbu__add');
    var closeBtn = el.querySelector('.tkm-cbu__close');
    addBtn && addBtn.addEventListener('click', function(){
      if(!UPSELL_VARIANT_ID) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:UPSELL_VARIANT_ID, quantity:1}]})
      }).then(function(r){
        if(!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        addBtn.textContent = '✓ Added';
        // Refresh cart drawer
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:added'));
        } catch(e){}
        setTimeout(function(){ if(el && el.parentNode) el.remove(); }, 1200);
      }).catch(function(){
        addBtn.disabled = false;
        addBtn.textContent = 'Add';
      });
    });
    closeBtn && closeBtn.addEventListener('click', function(){
      setCookie(DISMISS_COOKIE, '1', 7);
      el.remove();
    });
  }

  function isElementVisible(el){
    if(!el) return false;
    var r = el.getBoundingClientRect();
    if(r.width === 0 || r.height === 0) return false;
    var cs = window.getComputedStyle(el);
    if(cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    // Walk up checking parents are also visible
    var p = el.parentElement;
    while(p && p !== document.body){
      var pcs = window.getComputedStyle(p);
      if(pcs.display === 'none' || pcs.visibility === 'hidden') return false;
      p = p.parentElement;
    }
    return true;
  }

  function isCartDrawerOpen(){
    // Multiple possible markers across Shopify themes — drawer must be VISIBLE
    var markers = [
      '.bls__header_minicart.show',
      '.bls__header_minicart.is-open',
      '.bls__header_minicart.active',
      '.cart-drawer.is-open',
      '.cart-drawer.active',
      '.cart-drawer.open',
      'cart-drawer[open]',
      '[data-cart-drawer].is-open',
      '.drawer--cart.is-open',
      '.minicart.is-open',
      '.minicart.active'
    ];
    for(var i=0;i<markers.length;i++){
      var el = document.querySelector(markers[i]);
      if(el && isElementVisible(el)) return el;
    }
    // Fallback: check if any minicart-like element is actually visible on screen
    var candidates = document.querySelectorAll('.bls__header_minicart, .cart-drawer, [class*=minicart], cart-drawer');
    for(var j=0;j<candidates.length;j++){
      if(isElementVisible(candidates[j])){
        // Also need to check it's reasonably wide (drawers are wide; hidden divs are 0)
        var r = candidates[j].getBoundingClientRect();
        if(r.width > 200 && r.height > 200){
          return candidates[j];
        }
      }
    }
    return null;
  }

  function findInjectionTarget(drawerEl){
    if(!drawerEl) return null;
    /* TKMAUTO 2026-09-21 — bug fix: CHECKOUT pushed off-screen.
       This theme's drawer is `.bls-minicart-wrapper` (fixed, height 100vh)
       containing `.bls-minicart-content` which is ALSO height:100%. None of
       the selectors below used to match this theme, so `inner` came back null
       and the banner was inserted as a SIBLING above `.bls-minicart-content`.
       Wrapper height stayed 100vh, so the banner's 89px + 14px margin pushed
       the whole column down and the footer — VIEW CART and CHECKOUT — fell
       past the bottom of the viewport. The wrapper has overflow:visible and
       the body had overflow:hidden, so there was nothing to scroll: the
       buttons were simply unreachable.
       2026-09-21 second pass — the first fix injected INSIDE `.bls-items`.
       That looked right in one test but on the live drawer the banner ended
       up rendered ON TOP of the first line item (the theme re-renders
       `.bls-items` when the cart updates, and the line items inside it are
       laid out by the theme's own JS). Injecting into the item list is
       fragile no matter what.
       Verified-stable target: `.checkout-form`, inserted BEFORE
       `.bls-minicart-body`. `.checkout-form` is a flex column; the body is
       flex:1 so it simply shrinks by the banner's height, the footer
       (VIEW CART / CHECKOUT) does not move, and the banner sits in normal
       flow above the items with nothing overlapping it. Measured on a
       375×812 viewport: banner 193→298, first title at 310, CHECKOUT
       bottom 792 < 812. */
    var form = drawerEl.querySelector('.checkout-form');
    var body = drawerEl.querySelector('.bls-minicart-body');
    if(form && body && body.parentNode === form){
      return { parent: form, before: body };
    }
    var inner = drawerEl.querySelector('.cart-notification__content, .cart-drawer__items, .cart-items, .minicart-content, .cart-drawer__body, .bls__minicart-items');
    return { parent: inner || drawerEl, before: null };
  }

  function tryInject(cart){
    // Remove any orphan banners (drawer closed, etc)
    var existing = document.getElementById('tkmCbUpsell');
    if(existing && !isElementVisible(existing.closest('.bls__header_minicart, .cart-drawer, [class*=minicart], cart-drawer'))){
      existing.remove();
      existing = null;
    }
    if(!shouldShow(cart)){
      if(existing) existing.remove();
      return false;
    }
    if(!UPSELL_VARIANT_ID) return false;
    if(existing) return true; // already injected and visible
    var drawer = isCartDrawerOpen();
    if(!drawer) return false; // drawer not open — don't inject
    var target = findInjectionTarget(drawer);
    if(!target || !target.parent) return false;
    var banner = buildBanner();
    if(target.before){
      target.parent.insertBefore(banner, target.before);
    } else if(target.parent.firstChild){
      target.parent.insertBefore(banner, target.parent.firstChild);
    } else {
      target.parent.appendChild(banner);
    }
    attachAddHandler(banner);
    return true;
  }

  function refreshAndInject(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      tryInject(cart);
    }).catch(function(){});
  }

  // Init
  injectStyle();
  fetchUpsellProduct().then(function(){
    refreshAndInject();
    // Watch for cart drawer open / cart updates
    var events = ['cart:added','cart:refresh','cart:open','cart:updated','cart-drawer:open'];
    events.forEach(function(ev){
      document.addEventListener(ev, refreshAndInject);
    });
    // MutationObserver — re-inject if cart drawer DOM is recreated
    var mo = new MutationObserver(function(){ refreshAndInject(); });
    mo.observe(document.body, {childList:true, subtree:true});
    // Periodic safety net
    setInterval(refreshAndInject, 5000);
    // Hook into cart icons clicks
    document.addEventListener('click', function(e){
      var t = e.target;
      while(t && t !== document.body){
        if(t.matches && (t.matches('[data-cart-drawer-open]') || t.matches('.header-cart-trigger') || t.matches('.bls__minicart-trigger') || (t.tagName === 'A' && t.getAttribute('href') === '/cart'))){
          setTimeout(refreshAndInject, 350);
          break;
        }
        t = t.parentNode;
      }
    }, true);
  });
})();
